import { ThemeList } from 'store/ducks/globalTypes';

function ColorPalettes() {
  const colorPalettes = [
    {
      label: 'Deep Blue',
      value: ThemeList.DEEP_BLUE_THEME
    },
    {
      label: 'Deep Navy',
      value: ThemeList.DEEP_NAVY_THEME
    },
    {
      label: 'Dark',
      value: ThemeList.DARK_UI_THEME
    },
    {
      label: 'Arctic Horizon',
      value: ThemeList.LIGHT_UI_THEME
    },
    {
      label: 'Pink',
      value: ThemeList.PINK_UI_THEME
    },
    {
      label: 'Slate Steel',
      value: ThemeList.BLUISH_THEME
    },
    {
      label: 'Green',
      value: ThemeList.GREEN_MODE_THEME
    },
    {
      label: 'Lilac',
      value: ThemeList.LILAC_THEME
    },
    {
      label: 'Turquoise',
      value: ThemeList.TURQUOISE_THEME
    }
  ];

  return colorPalettes;
}

export default ColorPalettes;
